export const RECORRIDO_AREAS = [
  {
    area: "Perímetro",
    items: [
      { id: "bardas", label: "Bardas / Malla ciclónica" },
      { id: "iluminacion", label: "Iluminación Exterior" },
      { id: "bomba", label: "Cuarto de Bomba" },
      { id: "andenes", label: "Andenes, gatas y calzas" },
      { id: "cctv", label: "Cámaras de CCTV Exterior" },
      { id: "puertas_emergencia", label: "Puertas de emergencia" },
    ]
  },
  {
    area: "Oficinas Generales",
    items: [
      { id: "oficinas_computo", label: "Eq. Cómputo" },
      { id: "oficinas_mobiliario", label: "Mobiliario" },
    ]
  },
  {
    area: "Laboratorio",
    items: [
      { id: "lab_computo", label: "Eq. Cómputo" },
      { id: "lab_mobiliario", label: "Mobiliario" },
    ]
  },
  {
    area: "Comedor",
    items: [
      { id: "comedor_mesas", label: "Mesas" },
      { id: "comedor_refri", label: "Refrigeradores" },
      { id: "comedor_sillas", label: "Sillas" },
    ]
  },
  {
    area: "Planta",
    items: [
      { id: "planta_salidas", label: "Salidas de Emergencia Cerradas" },
      { id: "planta_cortinas", label: "Cortinas" },
    ]
  }
];

export const HORARIOS_RONDAS = ["04:00", "08:00", "12:00", "16:00", "20:00", "24:00"];
